import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
import { IconContainer, InfoBox, StationIcon, StationText, TextContainer, Wave } from "./GoogleMap.styles";
import { getStationIcon } from "./utils";
export var StationInfoBox = /*#__PURE__*/ forwardRef(function(param, ref) {
    var _closable = param.closable, closable = _closable === void 0 ? false : _closable, onClick = param.onClick, selected = param.selected, station = param.station;
    var handleClick = function() {
        if (onClick) {
            onClick(station.id);
        }
    };
    var Icon = getStationIcon(station.stationKind);
    return /*#__PURE__*/ _jsxs(InfoBox, {
        onClick: handleClick,
        selected: selected,
        ref: ref,
        children: [
            /*#__PURE__*/ _jsxs(IconContainer, {
                children: [
                    /*#__PURE__*/ _jsx(Wave, {}),
                    /*#__PURE__*/ _jsx(StationIcon, {
                        children: /*#__PURE__*/ _jsx(Icon, {
                            width: 24
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(TextContainer, {
                closable: closable,
                children: /*#__PURE__*/ _jsxs(StationText, {
                    as: "div",
                    variant: "body",
                    children: [
                        /*#__PURE__*/ _jsx("b", {
                            title: station.name,
                            children: station.name
                        }),
                        /*#__PURE__*/ _jsx("br", {}),
                        /*#__PURE__*/ _jsx("span", {
                            title: station.address,
                            children: station.address
                        })
                    ]
                })
            })
        ]
    }, station.id);
});
